<template>
  <div class="wt-container">
    <div class="row">
      <div class="col-md-12">
        <p class="introduction-text">
            This bar chart shows the annual {{cropText}} in {{assessment.getCountryOrBasinName(true)}}, {{countryOrBasinText}}.
        </p>
        <div>
          <label>Order by:
            <select v-model="orderPropertyName" @change="updateData()" class="order-select">
              <option :value="xPropertyName">name</option>
              <option value="greenWF">green water footprint</option>
              <option value="blueWF">blue water footprint</option>
              <option value="greyWF">grey water footprint</option>
              <option value="wf">total water footprint</option>
            </select>
          </label>
        </div>
        <BarStackedChart v-if="dataReady" id="main-stbar-chart" :data="data" :xAttrName="xPropertyName"></BarStackedChart>
      </div>
    </div>
  </div>
</template>

<script>
import BarStackedChart from "@/components/shared/BarStackedChart.vue"
import {
  countryCropsByCrop,
  basinCropsByCrop
} from "@/services/entity-model.js"
import { assessment } from "@/services/assessment-model.js"
import * as _ from 'lodash'

export default {
  name: "BarChartCt",
  components: {
    BarStackedChart,
  },
  mounted() {
    this.updateData();
  },
  data() {
    return {
      assessment: assessment,
      orderPropertyName: "blueWF",
      idName: "",
      dataReady: false,
      data: {},
      countryCropsByCrop: countryCropsByCrop,
      basinCropsByCrop: basinCropsByCrop
    }
  },
  computed: {
    cropText: function() {
      if ((assessment.crop == null) || (assessment.crop.cropID == 100001)) {
        return "green, blue and grey water footprint of all sectors and crops";
      } else if (assessment.crop.cropID == 10001) {
        return "green, blue and grey water footprint of agriculture (all crops)";
      } else if ((assessment.crop.cropID == 10002) || (assessment.crop.cropID == 10003)) {
        return "blue and grey water footprint of the " + assessment.crop.name.toLowerCase() + " sector";
      } else {
        return "green, blue and grey water footprint of " + assessment.crop.name.toLowerCase();
      }
    },
    countryOrBasinText: function() {
      if (assessment.assessmentType.name == "basins") {
        return "compared to other river basins";
      }
      if (assessment.assessmentType.name == "countries") {
        return "compared to other countries";
      }
      return "per country";
    },
    xPropertyName: function() {
      return assessment.assessmentType.name == "basins" ? "basinName" : "countryName";
    }
  },
  methods: {
    updateData() {
      const idName = assessment.assessmentType.name == "basins" ? "basinID" : "countryID";
      const selectedNames = _.map(assessment.countriesOrBasins, 'name') || [];
      const selectedIds = _.map(assessment.countriesOrBasins, idName) || [];
      const orderType = this.orderPropertyName === this.xPropertyName ? 'asc' : 'desc';
      var orderedData = [];

      if (assessment.assessmentType.name == "basins") {
        orderedData = _.orderBy(basinCropsByCrop, [this.orderPropertyName], [orderType]);
      } else {
        orderedData = _.orderBy(countryCropsByCrop, [this.orderPropertyName], [orderType]);
      }

      const data = {selected: [], others: []}
      data.others = _.filter(orderedData, (i) => !selectedIds.includes(i[idName]));
      data.selected = _.filter(orderedData, (i) => selectedIds.includes(i[idName]));
      this.data = { selected: selectedIds, values: _.concat(data.selected, data.others), selectedNames: selectedNames };
      if(this.data.values.length > 0) {
        this.dataReady = true;
      }
    }
  },
  watch: {
    "countryCropsByCrop": {
      handler: function () {
        this.updateData();
      },
      deep: true
    },
    "basinCropsByCrop":{ 
      handler: function () {
        this.updateData();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.order-select {
    height: 32px;
    margin: 0 8px 16px;
    border: 1px solid grey;
    border-radius: 5px;
    padding: 3px 8px;
    background: #fff;
}
</style>
